import { defineComponent, inject } from "vue";
import { isNullOrEmpty } from "../../../skyward.base.extensions";
import { OptionalVueProp, replaceDefaultVNode } from "../../core/vueHelpers";
import { classNames } from "../classes";
import { labeledDataListOptionsKey } from "./LabeledDataList";

export interface DataPartProps
{
    html?: string;
}

const DataPart = defineComponent<DataPartProps>({
    name: "DataPart",
    props:
    {
        html: OptionalVueProp(String)
    },
    setup(props, { slots })
    {
        const listOptions = inject(labeledDataListOptionsKey, {});

        return () =>
        {
            const classes =
            {
                [classNames.labeledDataPart]: true,
                [classNames.labeledDataData]: true,
                [classNames.visualLabel]: true,
                [classNames.selectorData]: listOptions.isForSelector,
                [classNames.legendOptionData]: listOptions.isForLegend
            };

            if (!isNullOrEmpty(props.html))
            {
                return (
                    <dd class={classes} innerHTML={props.html} />
                );
            }

            const blank = (
                <>
                    <span aria-hidden={"true"}>{"-"}</span>
                    <span class={classNames.srOnly}>{"Blank"}</span>
                </>
            );

            return (
                <dd class={classes}>{replaceDefaultVNode(slots.default?.(), blank)}</dd>
            );
        };
    }
});

export default DataPart;
